// extracted by mini-css-extract-plugin
module.exports = {"divider":"About_divider__CYGs-","About":"About_About__1fPNd","logos":"About_logos__2MXg7"};